// Libs
import React, { useState, Fragment, useRef, useEffect } from "react";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { useQueryParam, StringParam } from "use-query-params";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { gaEvent } from "../../utils/trackEvents";

// Components
import {
  HeaderContainer,
  SearchForm,
  AdvancedFiltersButton,
  HeaderContent,
  Space
} from "./HeaderStyle";
import { Input, Button } from "../../spocketUI";
import CategoriesSlider from "./header/CategoriesSlider";
import Autocomplete from "./header/Autocomplete";

// Actions
import { showModal } from "../../../actions/ui";

// Hooks
import usePrevious from "../../utils/hooks/usePrevious";

// Images
import filterIcon from "../../images/advanced-filters-icon.svg";
import zoomIcon from "../../images/zoom-icon.svg";

// i18n
import { useTranslation } from "react-i18next";

const Header = ({
  showModal,
  categoriesCardsOffsetHeight,
  categoriesCardsPosY
}) => {
  const { t } = useTranslation();

  // query parameters with serialization
  const [keywords, setKeywords] = useQueryParam("keywords", StringParam);
  const category = useQueryParam("category", StringParam)[0];

  // If the collection_id is present on the URL, it will trigger the collection view
  const collection_id = useQueryParam("collection_id", StringParam)[0];

  // local state
  const [wasSubmit, setWasSubmit] = useState("");
  const [stickyOnScroll, setStickyOnScroll] = useState(false);
  const [keywordsToBeSearched, setKeywordsToBeSearched] = useState(
    keywords || ""
  );

  const [selectedSuggestedWord, setSelectedSuggestedWord] = useState("");

  // const [categoriesCardsBreakpoint, setCategoriesCardsBreakpoint] = useState();
  const [showCategoriesCards, setShowCategoriesCards] = useState(false);

  /**
   * Reference to the children component to track width and height
   */
  const headerContainerRef = useRef();

  const prevAmount = usePrevious({ keywords });

  useEffect(
    () => {
      const categoriesCardsBreakpoint =
        categoriesCardsOffsetHeight - headerContainerRef.current.offsetHeight;

      setShowCategoriesCards(
        categoriesCardsPosY <= -Math.abs(categoriesCardsBreakpoint)
      );
    },
    [categoriesCardsOffsetHeight, categoriesCardsPosY, headerContainerRef]
  );

  // Clearing the local state setKeywordsToBeSearched when the query string keywords is undefined
  useEffect(
    () => {
      // Checking if prevAmount hook exists.
      if (prevAmount !== undefined) {
        if (prevAmount.keywords !== keywords && keywords === undefined) {
          setKeywordsToBeSearched("");
        }
      }
    },
    [keywords, prevAmount]
  );

  // HeaderContainer scroll position
  useScrollPosition(
    ({ currPos }) => {
      currPos.y <= 0 ? setStickyOnScroll(true) : setStickyOnScroll(false);
    },
    [],
    headerContainerRef,
    false
  );

  useEffect(
    () => {
      if (keywordsToBeSearched === selectedSuggestedWord) {
        setSelectedSuggestedWord("");
      }
    },
    [keywordsToBeSearched, selectedSuggestedWord, setSelectedSuggestedWord]
  );

  const handleSubmit = event => {
    setSelectedSuggestedWord(selectedSuggestedWord);
    setKeywords(
      selectedSuggestedWord ? selectedSuggestedWord : keywordsToBeSearched,
      "pushIn"
    );

    selectedSuggestedWord &&
      gaEvent({ category: "Search Page", action: "Suggestion Clicked" });

    // It is firing setResults([]) into the Autocomplete component;
    setWasSubmit(Date.now());

    event.preventDefault();
  };

  const headerContent = type => {
    return (
      <HeaderContent className="Header__HeaderContent">
        <SearchForm
          onSubmit={event => {
            handleSubmit(event);

            if (type === "sticky") {
              scrollToTop();
            }
          }}
        >
          <Input
            variant="extraBig"
            name={type === "sticky" ? "sticky-keywords" : "keywords"}
            placeholder={t("Search.Header.PlaceHolder.Search")}
            value={
              selectedSuggestedWord
                ? selectedSuggestedWord
                : keywordsToBeSearched
            }
            onChange={event => {
              setKeywordsToBeSearched(event.target.value);
              setSelectedSuggestedWord("");
            }}
          />
          <Button variant="brandBig" type="submit">
            <img src={zoomIcon} alt="Zoom" />
            {t("Search.Header.Button.Search")}
          </Button>

          <Autocomplete
            keywords={keywords}
            wasSubmit={wasSubmit}
            searchTerm={keywordsToBeSearched}
            setSelectedSuggestedWord={setSelectedSuggestedWord}
          />
        </SearchForm>
        <AdvancedFiltersButton
          onClick={() => showModal("ADVANCED_FILTERS_MODAL")}
          className="intercom__advanced-filters-button"
        >
          <img src={filterIcon} alt="Filter" />
          {t("Search.Header.Button.Filters")}
        </AdvancedFiltersButton>
      </HeaderContent>
    );
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Fragment>
      <HeaderContainer sticky={false} ref={headerContainerRef}>
        {headerContent()}
        {category || keywords || collection_id ? (
          <CategoriesSlider />
        ) : (
          <Space />
        )}
      </HeaderContainer>

      <HeaderContainer
        sticky={true}
        style={{ display: stickyOnScroll ? "flex" : "none" }}
      >
        {headerContent("sticky")}

        {showCategoriesCards || category || keywords || collection_id ? (
          <CategoriesSlider onClick={() => scrollToTop()} />
        ) : (
          <Space />
        )}
      </HeaderContainer>
    </Fragment>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showModal }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/Header.js